<template>
  <v-alert
    type="error"
    :value="true"
    v-show="getUnconfiguredRecipe > 0"
    dismissible
  >
    <v-row align="center" justify="start" no-gutters
      ><span class="title">
        {{ getUnconfiguredRecipe }} recettes ne sont pas configurées pour cette
        succursale.</span
      ></v-row
    >
    <v-row align="center" justify="start">
      <RecipeImportDialog></RecipeImportDialog>
    </v-row>
  </v-alert>
</template>

<script>
import { mapGetters } from "vuex";
import RecipeImportDialog from "./RecipeImportDialog";
export default {
  name: "RecipeConfigurationNotification",
  components: {
    RecipeImportDialog
  },
  computed: {
    ...mapGetters(["getRecipes"]),
    getUnconfiguredRecipe() {
      let count = 0;
      this.getRecipes.forEach(x => {
        if (!x.data && x.is_deleted === false) {
          count += 1;
        }
      });
      return count;
    }
  }
};
</script>

<style></style>
